// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"4fd2a9b0","277":"022fc46e"}[chunkId] + ".chunk.css";
};